export default {
  // Same IP User Warning
  'riskDimension.ip.title': 'Alerta de usuario con IP igual',
  'riskDimension.ip.ipAddress': 'Dirección IP',
  'riskDimension.ip.ipAddressPlaceholder': 'Ingresar dirección IP',
  'riskDimension.ip.memberAccount': 'Nombre de usuario',
  'riskDimension.ip.memberAccountPlaceholder': 'Ingresar nombre de usuario',
  'riskDimension.ip.minMemberCount': 'Recuento mínimo asociado ≥',
  'riskDimension.ip.minMemberCountPlaceholder': 'Ingresar',
  'riskDimension.ip.minRiskCount': 'Recuento mínimo de riesgo ≥',
  'riskDimension.ip.minRiskCountPlaceholder': 'Ingresar',
  'riskDimension.ip.query': 'Buscar',
  'riskDimension.ip.reset': 'Restablecer',
  'riskDimension.ip.export': 'Exportar',

  // Table Columns
  'riskDimension.ip.table.ipAddress': 'Dirección IP',
  'riskDimension.ip.table.totalMembers': 'Total de miembros',
  'riskDimension.ip.table.riskMembers': 'Miembros de riesgo',
  'riskDimension.ip.table.details': 'Detalles',
  'riskDimension.ip.table.lastUpdateTime': 'Última actualización',
  'riskDimension.ip.table.action': 'Acción',
  'riskDimension.ip.table.view': 'Ver',
  'riskDimension.ip.table.expand': 'Expandir',
  'riskDimension.ip.table.more': 'Más',
  'riskDimension.ip.table.total': 'Total {total} registros',

  // Quick View Modal
  'riskDimension.ip.quickView.title': 'Usuarios asociados',
  'riskDimension.ip.quickView.ipLabel': 'Dirección IP',
  'riskDimension.ip.quickView.searchPlaceholder': 'Buscar cuenta',
  'riskDimension.ip.quickView.noResults': 'No se encontraron cuentas',
  'riskDimension.ip.quickView.showing': 'Mostrando',

  // Detail Modal
  'riskDimension.ip.detail.title': 'Dirección IP',
  'riskDimension.ip.detail.summary': 'Total {total} usuarios, {risk} con control de riesgo',
  'riskDimension.ip.detail.batchSetRisk': 'Establecer nivel de riesgo por lotes',
  'riskDimension.ip.detail.searchPlaceholder': 'Buscar nombre de usuario',
  'riskDimension.ip.detail.search': 'Buscar',
  'riskDimension.ip.detail.select': 'Seleccionar',
  'riskDimension.ip.detail.memberAccount': 'Nombre de usuario',
  'riskDimension.ip.detail.currentRisk': 'Riesgo actual',
  'riskDimension.ip.detail.setRiskLevel': 'Establecer nivel de riesgo',
  'riskDimension.ip.detail.batchSetPending': 'Establecimiento por lotes de nivel de riesgo pendiente',

  // Risk Levels
  'riskDimension.riskLevel.limitLogin': 'Limitar acceso',
  'riskDimension.riskLevel.limitDeposits': 'Limitar depósitos',
  'riskDimension.riskLevel.limitWithdrawal': 'Limitar retiro',
  'riskDimension.riskLevel.limitDiscount': 'Limitar descuento',
  'riskDimension.riskLevel.potentialRisk': 'Riesgo potencial',
  'riskDimension.riskLevel.sameIp': 'Riesgo de IP igual',
  'riskDimension.riskLevel.sameDevice': 'Riesgo de dispositivo igual',
  'riskDimension.riskLevel.sameBankCard': 'Riesgo de tarjeta bancaria igual',
  'riskDimension.riskLevel.sameWallet': 'Riesgo de billetera igual',

  // Set Risk Level Modal
  'riskDimension.setRisk.title': 'Establecer nivel de riesgo',
  'riskDimension.setRisk.batchTitle': 'Establecer nivel de riesgo por lotes',
  'riskDimension.setRisk.members': 'miembros',
  'riskDimension.setRisk.riskLevel': 'Nivel de riesgo',
  'riskDimension.setRisk.selectPlaceholder': 'Seleccionar nivel de riesgo',
  'riskDimension.setRisk.loginLimitType': 'Tipo de límite de acceso',
  'riskDimension.setRisk.loginLimitTypePlaceholder': 'Seleccionar tipo de límite de acceso',
  'riskDimension.setRisk.loginLimitTypeRequired': 'Por favor, seleccionar tipo de límite de acceso',
  'riskDimension.setRisk.remark': 'Observación',
  'riskDimension.setRisk.remarkPlaceholder': 'Ingresar observación',
  'riskDimension.setRisk.confirm': 'Confirmar',
  'riskDimension.setRisk.cancel': 'Cancelar',
  'riskDimension.setRisk.success': 'Nivel de riesgo establecido correctamente',
  'riskDimension.setRisk.batchSuccess': 'Establecimiento por lotes exitoso, {count} miembros actualizados',
  'riskDimension.setRisk.error': 'Error al establecer nivel de riesgo',
  'riskDimension.setRisk.missingMemberId': 'ID de miembro faltante',

  // Detail Modal
  'riskDimension.ip.detail.selectMembersFirst': 'Por favor, seleccionar miembros primero',

  // Messages
  'riskDimension.message.queryFailed': 'Consulta fallida',
  'riskDimension.message.queryMemberListFailed': 'Error al consultar lista de miembros',
  'riskDimension.message.exportLoading': 'Creando tarea de exportación, por favor espere...',
  'riskDimension.message.exportSuccess': 'Tarea de exportación creada exitosamente. Por favor, revisar la lista de descargas.',
  'riskDimension.message.exportFailed': 'Error en exportación',

  // Same Device User Warning
  'riskDimension.device.title': 'Alerta de usuario con dispositivo igual',
  'riskDimension.device.deviceId': 'ID de dispositivo',
  'riskDimension.device.deviceIdPlaceholder': 'Ingresar ID de dispositivo',
  'riskDimension.device.memberAccount': 'Nombre de usuario',
  'riskDimension.device.memberAccountPlaceholder': 'Ingresar nombre de usuario',
  'riskDimension.device.minMemberCount': 'Recuento mínimo asociado ≥',
  'riskDimension.device.minMemberCountPlaceholder': 'Ingresar',
  'riskDimension.device.minRiskCount': 'Recuento mínimo de riesgo ≥',
  'riskDimension.device.minRiskCountPlaceholder': 'Ingresar',
  'riskDimension.device.query': 'Buscar',
  'riskDimension.device.reset': 'Restablecer',
  'riskDimension.device.export': 'Exportar',
  'riskDimension.device.table.deviceId': 'ID de dispositivo',
  'riskDimension.device.table.totalMembers': 'Total de miembros',
  'riskDimension.device.table.riskMembers': 'Miembros de riesgo',
  'riskDimension.device.table.details': 'Detalles',
  'riskDimension.device.table.lastUpdateTime': 'Última actualización',
  'riskDimension.device.table.action': 'Acción',
  'riskDimension.device.table.view': 'Ver',
  'riskDimension.device.table.more': 'Más',
  'riskDimension.device.table.total': 'Total {total} registros',
  'riskDimension.device.detail.title': 'ID de dispositivo',
  'riskDimension.device.detail.summary': 'Total {total} usuarios, {risk} con control de riesgo',
  'riskDimension.device.detail.batchSetRisk': 'Establecer nivel de riesgo por lotes',
  'riskDimension.device.detail.searchPlaceholder': 'Buscar nombre de usuario',
  'riskDimension.device.detail.search': 'Buscar',
  'riskDimension.device.detail.memberAccount': 'Nombre de usuario',
  'riskDimension.device.detail.currentRisk': 'Riesgo actual',
  'riskDimension.device.detail.setRiskLevel': 'Establecer nivel de riesgo',
  'riskDimension.device.detail.selectMembersFirst': 'Por favor, seleccionar miembros primero',
  'riskDimension.device.quickView.title': 'Usuarios asociados',
  'riskDimension.device.quickView.deviceLabel': 'ID de dispositivo',
  'riskDimension.device.quickView.searchPlaceholder': 'Buscar cuenta',
  'riskDimension.device.quickView.noResults': 'No se encontraron cuentas',
  'riskDimension.device.quickView.showing': 'Mostrando',

  // Same Bank Card User Warning
  'riskDimension.bank.title': 'Alerta de usuario con tarjeta bancaria igual',
  'riskDimension.bank.bankCard': 'Número de tarjeta bancaria',
  'riskDimension.bank.bankCardPlaceholder': 'Ingresar número de tarjeta bancaria',
  'riskDimension.bank.bankAccountName': 'Nombre de cuenta bancaria',
  'riskDimension.bank.bankAccountNamePlaceholder': 'Ingresar nombre de cuenta bancaria',
  'riskDimension.bank.memberAccount': 'Nombre de usuario',
  'riskDimension.bank.memberAccountPlaceholder': 'Ingresar nombre de usuario',
  'riskDimension.bank.minMemberCount': 'Recuento mínimo asociado ≥',
  'riskDimension.bank.minMemberCountPlaceholder': 'Ingresar',
  'riskDimension.bank.minRiskCount': 'Recuento mínimo de riesgo ≥',
  'riskDimension.bank.minRiskCountPlaceholder': 'Ingresar',
  'riskDimension.bank.query': 'Buscar',
  'riskDimension.bank.reset': 'Restablecer',
  'riskDimension.bank.export': 'Exportar',
  'riskDimension.bank.table.bankCard': 'Número de tarjeta bancaria',
  'riskDimension.bank.table.bankAccountName': 'Nombre de cuenta bancaria',
  'riskDimension.bank.table.totalMembers': 'Total de miembros',
  'riskDimension.bank.table.riskMembers': 'Miembros de riesgo',
  'riskDimension.bank.table.details': 'Detalles',
  'riskDimension.bank.table.lastUpdateTime': 'Última actualización',
  'riskDimension.bank.table.action': 'Acción',
  'riskDimension.bank.table.view': 'Ver',
  'riskDimension.bank.table.more': 'Más',
  'riskDimension.bank.table.total': 'Total {total} registros',
  'riskDimension.bank.detail.title': 'Número de tarjeta bancaria',
  'riskDimension.bank.detail.summary': 'Total {total} usuarios, {risk} con control de riesgo',
  'riskDimension.bank.detail.batchSetRisk': 'Establecer nivel de riesgo por lotes',
  'riskDimension.bank.detail.searchPlaceholder': 'Buscar nombre de usuario',
  'riskDimension.bank.detail.search': 'Buscar',
  'riskDimension.bank.detail.memberAccount': 'Nombre de usuario',
  'riskDimension.bank.detail.currentRisk': 'Riesgo actual',
  'riskDimension.bank.detail.setRiskLevel': 'Establecer nivel de riesgo',
  'riskDimension.bank.detail.selectMembersFirst': 'Por favor, seleccionar miembros primero',
  'riskDimension.bank.quickView.title': 'Usuarios asociados',
  'riskDimension.bank.quickView.bankCardLabel': 'Número de tarjeta bancaria',
  'riskDimension.bank.quickView.searchPlaceholder': 'Buscar cuenta',
  'riskDimension.bank.quickView.noResults': 'No se encontraron cuentas',
  'riskDimension.bank.quickView.showing': 'Mostrando',

  // Same Wallet User Warning
  'riskDimension.wallet.title': 'Alerta de usuario con billetera igual',
  'riskDimension.wallet.walletNumber': 'Número de billetera',
  'riskDimension.wallet.walletNumberPlaceholder': 'Ingresar número de billetera',
  'riskDimension.wallet.walletType': 'Tipo de billetera',
  'riskDimension.wallet.walletTypePlaceholder': 'Seleccionar tipo de billetera',
  'riskDimension.wallet.walletType.USDT': 'USDT',
  'riskDimension.wallet.walletType.BTC': 'BTC',
  'riskDimension.wallet.walletType.ETH': 'ETH',
  'riskDimension.wallet.walletType.OTHER': 'Otro',
  'riskDimension.wallet.memberAccount': 'Nombre de usuario',
  'riskDimension.wallet.memberAccountPlaceholder': 'Ingresar nombre de usuario',
  'riskDimension.wallet.minMemberCount': 'Recuento mínimo asociado ≥',
  'riskDimension.wallet.minMemberCountPlaceholder': 'Ingresar',
  'riskDimension.wallet.minRiskCount': 'Recuento mínimo de riesgo ≥',
  'riskDimension.wallet.minRiskCountPlaceholder': 'Ingresar',
  'riskDimension.wallet.query': 'Buscar',
  'riskDimension.wallet.reset': 'Restablecer',
  'riskDimension.wallet.export': 'Exportar',
  'riskDimension.wallet.table.walletNumber': 'Número de billetera',
  'riskDimension.wallet.table.walletType': 'Tipo de billetera',
  'riskDimension.wallet.table.totalMembers': 'Total de miembros',
  'riskDimension.wallet.table.riskMembers': 'Miembros de riesgo',
  'riskDimension.wallet.table.details': 'Detalles',
  'riskDimension.wallet.table.lastUpdateTime': 'Última actualización',
  'riskDimension.wallet.table.action': 'Acción',
  'riskDimension.wallet.table.view': 'Ver',
  'riskDimension.wallet.table.more': 'Más',
  'riskDimension.wallet.table.total': 'Total {total} registros',
  'riskDimension.wallet.detail.title': 'Número de billetera',
  'riskDimension.wallet.detail.summary': 'Total {total} usuarios, {risk} con control de riesgo',
  'riskDimension.wallet.detail.batchSetRisk': 'Establecer nivel de riesgo por lotes',
  'riskDimension.wallet.detail.searchPlaceholder': 'Buscar nombre de usuario',
  'riskDimension.wallet.detail.search': 'Buscar',
  'riskDimension.wallet.detail.memberAccount': 'Nombre de usuario',
  'riskDimension.wallet.detail.currentRisk': 'Riesgo actual',
  'riskDimension.wallet.detail.setRiskLevel': 'Establecer nivel de riesgo',
  'riskDimension.wallet.detail.selectMembersFirst': 'Por favor, seleccionar miembros primero',
  'riskDimension.wallet.quickView.title': 'Usuarios asociados',
  'riskDimension.wallet.quickView.walletNumberLabel': 'Número de billetera',
  'riskDimension.wallet.quickView.searchPlaceholder': 'Buscar cuenta',
  'riskDimension.wallet.quickView.noResults': 'No se encontraron cuentas',
  'riskDimension.wallet.quickView.showing': 'Mostrando',
};

